import { setMockupPreviewAction as setMockupPreviewOperation } from 'editor/src/store/mockup/slice';

export default setMockupPreviewOperation;
